
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"46","height":"45","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_1914_28229)"}},[_c('path',{attrs:{"d":"M38 0H8C3.86 0 .5 3.36.5 7.5v30C.5 41.64 3.86 45 8 45h30c4.14 0 7.5-3.36 7.5-7.5v-30C45.5 3.36 42.14 0 38 0z","fill":"#EEEEFE"}}),_c('path',{attrs:{"d":"M36.11 13.82c0-.58-.11-1.16-.34-1.7a4.38 4.38 0 00-.96-1.44c-.41-.41-.9-.74-1.44-.96-.54-.22-1.12-.34-1.7-.34H14.32c-1.18 0-2.31.47-3.14 1.3-.83.83-1.3 1.96-1.3 3.14v17.34c0 1.18.47 2.31 1.3 3.14.83.83 1.96 1.3 3.14 1.3h17.36c1.18 0 2.31-.47 3.14-1.3.83-.83 1.3-1.96 1.3-3.14V16.44l-.02-2.62h.01zm-2.42 17.12c0 .53-.21 1.27-.59 1.64-.38.38-.89.59-1.42.59H14.32c-.53 0-1.04-.21-1.42-.59-.38-.38-.59-.89-.59-1.42V13.82c0-.53.21-1.04.59-1.42.38-.38.89-.59 1.42-.59h17.34c.26 0 .52.05.77.15.24.1.46.25.65.43a1.992 1.992 0 01.58 1.42v2.12l.02 6.56v8.44l.01.01z","fill":"#5858EC"}}),_c('path',{attrs:{"d":"M27.04 21.28h-2.32a.5.5 0 01-.35-.14.515.515 0 01-.15-.36v-2.32c0-.67-.55-1.22-1.22-1.22-.67 0-1.22.55-1.22 1.22v2.32a.49.49 0 01-.5.5h-2.32c-.67 0-1.22.55-1.22 1.22 0 .67.55 1.22 1.22 1.22h2.32c.14 0 .26.06.35.15.09.09.15.22.15.35v2.32c0 .67.55 1.22 1.22 1.22.67 0 1.22-.55 1.22-1.22v-2.32c0-.14.06-.26.15-.35a.51.51 0 01.35-.15h2.32c.67 0 1.22-.55 1.22-1.22 0-.67-.55-1.22-1.22-1.22z","fill":"#5858EC"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_1914_28229"}},[_c('rect',{attrs:{"width":"45","height":"45","fill":"#fff","transform":"translate(.5)"}})])])])
          )
        }
      }
    